import axios from 'axios';

import firebase from 'src/utils/firebase';
import { buildApiUrl } from 'src/utils/api';
import { activeShopHeaders } from 'src/utils/shopContext';

export const searchAutoClever = async (query, limit = 5) => {
  const currentUser = firebase.auth().currentUser;
  if (!currentUser) {
    throw new Error('Your session has expired. Sign in again to search.');
  }

  const response = await axios.get(buildApiUrl('/api/global-search'), {
    params: { q: query, limit },
    headers: {
      Authorization: `Bearer ${await currentUser.getIdToken()}`,
      ...activeShopHeaders()
    }
  });

  return response.data;
};
